/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import "./P2PMainComp.css";
import styles from "./P2PMainComp.module.css";
import DomainTile from "../../components/DomainTile/DomainTile";
import BarLineChart from "../../atomicComponents/BarLineChart/BarLineChart";
import DashboardSection from "./DashboardSection";
import InfoCards from "../../components/TransitionPageComp/InfoCards/InfoCards";
import { useHistory } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";
import { setQuarter } from "date-fns";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../constants";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import TileComp from "./TileComp/TileComp";
import Marquee from "react-fast-marquee";

function AgratasP2PMainComp() {
  const history = useHistory();

  const location = useLocation();

  const token = localStorage.getItem('ApiToken');

  const initialFilters = location.state || {
    entityData: null,
    yearData: null,
    monthData: null,
    quarterData: null,
  };
  const quarterOptionss = [
    // { value: "undefined", label: "Select" },
    // { value: "0", label: "-All-" },
    { value: "2", label: "Q1" },
    { value: "3", label: "Q2" },
    { value: "4", label: "Q3" },
    { value: "1", label: "Q4" },
  ];

  const monthOptionss = [
    { value: "1", label: "Jan" },
    { value: "2", label: "Feb" },
    { value: "3", label: "Mar" },
    { value: "4", label: "Apr" },
    { value: "5", label: "May" },
    { value: "6", label: "Jun" },
    { value: "7", label: "Jul" },
    { value: "8", label: "Aug" },
    { value: "9", label: "Sep" },
    { value: "10", label: "Oct" },
    { value: "11", label: "Nov" },
    { value: "12", label: "Dec" },
  ];

  const quarterToMonths = {
    2: ["4", "5", "6"], // Apr–Jun
    3: ["7", "8", "9"], // Jul–Sep
    4: ["10", "11", "12"], // Oct–Dec
    1: ["1", "2", "3"], // Jan–Mar
  };

  // const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const [hasApplied, setHasApplied] = useState(false);

  const [filters, setFilters] = useState(initialFilters);

  const { API_BASE_URL } = config;

  const { showPopup } = usePopupManager();

  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState(monthOptionss);
  const [quarterOptions, setQuarterOptions] = useState(quarterOptionss);

  const [RefreshedDate, setRefreshedDate] = useState([]);

  const currentDateTime = new Date;
  const yeasterdayDate = new Date(currentDateTime);
  yeasterdayDate.setDate(currentDateTime.getDate()-1);
  const stripedYesterrdayDate = yeasterdayDate.toLocaleDateString();

  const [entity, setEntity] = useState([]);
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
  const [quarter, setQuarter] = useState([]);

  const [POCreationData, setPOCreationData] = useState([]);
  const [SCSData, setSCSData] = useState([]);
  const [MDMData, setMDMData] = useState([]);
  const [InvoiceData, setInvoiceData] = useState([]);
  const [VendorQueriesData, setVendorQueriesData] = useState([]);
  const [VendorReconData, setVendorReconData] = useState([]);
  const [CardData, setCardData] = useState([]);

  const [rolesDataFetched, setRolesDataFetched] = useState(false);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "20px",
      flexWrap: "wrap",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "50px",
      overflowY: "auto",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: "visible",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      overflowX: "auto",
      whiteSpace: "nowrap",
    }),
    option: (provided) => ({
      ...provided,
      padding: "8px 12px",
    }),
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-entity-dropdown`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          if (roles["entity"] === "Agratas") {
            setEntityOptions(response.data[0].agratas);
          } else {
            setEntityOptions(response.data[0].all);
          }
          setRolesDataFetched(true);
        });
    } catch (error) {
      console.error("Error fetching finance-entity options:", error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-year-dropdown`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setYearOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-year options:", error);
    }
  };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-month-dropdown`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setMonthOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-month options:", error);
    }
  };

  const fetchRefreshedDate = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-Refreshed-Date`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setRefreshedDate(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-month options:", error);
    }
  };

  const fetchAgratasKPIData = async () => {
    const entityval = filters?.entityData?.value || entity?.value;
    const yearval = filters?.yearData?.value || year?.value;
    // const yearval =
    //   filters?.yearData?.map((m) => m.value) ||
    //   year?.map((m) => m.value) ||
    //   [];
    const monthval =
      filters?.monthData?.map((m) => m.value) ||
      month?.map((m) => m.value) ||
      [];
    const quarterval = filters?.quarterData?.value || quarter?.value;

    if (!entityval) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    setIsLoading(true);

    const kpiTypes = [
      "POCreation",
      "SCSCreation",
      "MDMEntries",
      "InvoiceVerification",
      "VendorQueries",
      "VendorReconciliation",
    ];

    try {
      const responses = await Promise.all(
        kpiTypes.map((kpiType) =>
          axios.post(
            `${API_BASE_URL}/api/P2P-AgratasKPI_drilldown`,
            {
              selectedEntity: entityval,
              selectedYear: yearval,
              selectedMonth: monthval,
              selectedQuarter: quarterval,
              kpiType: kpiType,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                // Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
        )
      );

      setPOCreationData(responses[0].data || []);
      setSCSData(responses[1].data || []);
      setMDMData(responses[2].data || []);
      setInvoiceData(responses[3].data || []);
      setVendorQueriesData(responses[4].data || []);
      setVendorReconData(responses[5].data || []);

      setShowDashboard(true);
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      showPopup({
        type: MESSAGE_TYPE.ERROR,
        contextText: MESSAGE_TYPE.ERROR,
        info: "Failed to fetch KPI data. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const generateDataset = (data) => {
    if (!data || data.length === 0) return [];

    return [
      {
        type: "line",
        label: "Accuracy %",
        data: data.map((item) => item.accuracy),
        borderColor: "#90EE90",
        backgroundColor: "#90EE90",
        yAxisID: "y1",
        tension: 0.4,
        fill: false,
        pointRadius: 6,
      },
      {
        type: "line",
        label: "Timeliness",
        data: data.map((item) => item.timeliness),
        borderColor: "#800080",
        backgroundColor: "#800080",
        yAxisID: "y1",
        tension: 0.8,
        fill: false,
        pointRadius: 8,
      },
      {
        type: "bar",
        label: "Within SLA",
        data: data.map((item) => item.withinSLA),
        backgroundColor: "#0072CE",
      },
      {
        type: "bar",
        label: "Outside SLA",
        data: data.map((item) => item.outsideSLA),
        backgroundColor: "#FF0000",
      },
    ];
  };

  const fetchCardData = async () => {
    const entityval = filters?.entityData?.value || entity?.value;
    const yearval = filters?.yearData?.value || year?.value;
    // const yearval =
    // filters?.yearData?.map((m) => m.value) ||
    // year?.map((m) => m.value) ||
    // [];
    const monthval =
      filters?.monthData?.map((m) => m.value) ||
      month?.map((m) => m.value) ||
      [];
    const quarterval = filters?.quarterData?.value || quarter?.value;
    try {
      const response = await axios
        .post(
          `${API_BASE_URL}/api/P2P-AgratasCardData_drilldown`,
          {
            selectedEntity: entityval,
            selectedYear: yearval,
            selectedMonth: monthval,
            selectedQuarter: quarterval,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              // Authorization: "Basic YWRtaW4xOjEyMw==",
            },
          }
        )
        .then((response) => {
          const result = response.data;
          setCardData(result);
        });
    } catch (error) {
      console.error("Error fetching total contract value options:", error);
    }
  };

  const hasRedirected = useRef(false);


  const handleApply = (changed = {}) => {
    // const entityValue = entity?.value?.toLowerCase() || "";

    // if(entityValue != 'all'){
    //   const routeKey = Object.keys(entityRouteMap).find((key) =>
    //   entityValue.includes(key)
    // );

    // let targetRoute = "/Procure-To-Pay";

    // if (routeKey) {
    //   targetRoute = entityRouteMap[routeKey];
    // }

    // if (!hasRedirected.current) {
    //   hasRedirected.current = true;
    //   history.push(targetRoute, {
    //     entityData: entity,
    //     yearData: year,
    //     quarterData: quarter,
    //     monthData: month,
    //   });
    // }
    // }

    
    const entityRouteMap = {
      agratas: "/Procure-To-Pay/Agratas-Main",
      jlr: "/Procure-To-Pay/JLR-Main",
    };
    
    const entityValue = entity?.value?.toLowerCase();
    let entitySlice = entityValue?.split(" ")[0] || "agratas";
    // console.log("entityvalue---------:", entitySlice);
    
    let targetRoute = "/Procure-To-Pay"
    
    if (entitySlice !== "all") {
      const routeKey = Object.keys(entityRouteMap).find((key) =>
      entitySlice.includes(key)
      );
    
      if (routeKey) {
        targetRoute = entityRouteMap[routeKey];
      }
    }
    
    if (!hasRedirected.current) {
      hasRedirected.current = true;
    
      history.push(targetRoute, {
        entityData: entity,
        yearData: year,
        quarterData: quarter,
        monthData: month,
      });
    }

    if (Array.isArray(entity) && entity.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    if (Array.isArray(year) && year.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select year.",
      });
      return;
    }

    if (entity?.value) {
      fetchAgratasKPIData();
      fetchCardData();
    } else {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
    }
  };

  useEffect(() => {
    hasRedirected.current = false;
  }, [entity]);

  const handleEntityChange = (selected) => {
    if (selected) {
      setEntity(selected);
      setFilters((prev) => ({ ...prev, entityData: selected }));
    } else {
      setEntity([]);
    }
  };

  const handleYearChange = (selected) => {
    if (selected) {
      setYear(selected);
      setFilters((prev) => ({ ...prev, yearData: selected }));
    } else {
      setYear([]);
    }
    // setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleMonthChange = (selected) => {
    if (selected && selected.length > 0) {
      setMonth(selected);
      setFilters((prev) => ({ ...prev, monthData: selected }));
    } else {
      setMonth([]);
    }
  };

  const handleQuarterChange = (selected) => {
    if (selected && selected.length > 0) {
      setQuarter(selected);
      setFilters((prev) => ({ ...prev, quarterData: selected }));
      const selectedMonths = selected.flatMap(
        (q) => quarterToMonths[q.value] || []
      );
      const filteredMonths = monthOptionss.filter((m) =>
        selectedMonths.includes(m.value)
      );
      setMonth(filteredMonths);
      setFilters((prev) => ({ ...prev, monthData: filteredMonths }));
    } else {
      setQuarter([]);
      setMonth([]);
      setFilters((prev) => ({
        ...prev,
        quarterData: [],
        monthData: [],
      }));
    }
  };

  const handleReset = () => {
    setShowDashboard(false);
    setEntity(null);
    setYear(null);
    setMonth(null);
    setQuarter(null);
  };

  useEffect(() => {
    if (roles && !rolesDataFetched) {
      fetchEntityOptions();
      fetchYearOptions();
      fetchMonthOptions();
      fetchRefreshedDate();
      // fetchQuarterOptions();
    }
  }, [roles, rolesDataFetched]);

  useEffect(() => {
    if (
      entityOptions.length &&
      yearOptions.length &&
      monthOptions.length &&
      quarterOptions.length
    ) {
      if (filters.entityData) {
        const ent = entityOptions.find(
          (opt) => opt.value === filters.entityData.value
        );
        if (ent) setEntity(ent);
      }

      if (filters.yearData) {
        const yr = yearOptions.find(
          (opt) => opt.value === filters.yearData.value
        );
      //   const yr = yearOptions.filter((opt) =>
      //   filters.yearData.some((m) => m.value === opt.value)
      // );
        if (yr) {
          setYear(yr);
          // shouldApply = true;
        }
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptionss.filter((opt) =>
          filters.monthData.some((m) => m.value === opt.value)
        );
        if (mon.length > 0) setMonth(mon);
      }
      if (filters.quarterData && filters.quarterData.length > 0) {
        const qtr = quarterOptionss.filter((opt) =>
          filters.quarterData.some((m) => m.value === opt.value)
        );
        if (qtr.length > 0) setQuarter(qtr);
      }

      setHasApplied(true);
    }
  }, [entityOptions, yearOptions, monthOptions, quarterOptions]);

  useEffect(() => {
    if (hasApplied === true) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  const paidOnTimeGradient = 'linear-gradient(135deg, #F43F5E 0%, #DB2777 100%)';
  const blueGradient = 'linear-gradient(135deg, #3B82F6 0%, #4F46E5 100%)';
  const indigoGradient = 'linear-gradient(135deg, #6366F1 0%, #7C3AED 100%)';
  const purpleGradient = 'linear-gradient(135deg, #8B5CF6 0%, #C026D3 100%)';
  const emeraldGradient = 'linear-gradient(135deg, #10B981 0%, #0D9488 100%)';
  const amberGradient = 'linear-gradient(135deg, #FBBF24 0%, #F97316 100%)';

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>
              Entity <span style={{ color: "red" }}>*</span>
            </label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                // onChange={setEntity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={true}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Fiscal Year
            <span style={{ color: "red" }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                // onChange={setYear}
                onChange={handleYearChange}
                options={yearOptions}
                // isMulti={true}
                isSearchable={true}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                // onChange={setQuarter}
                onChange={handleQuarterChange}
                options={quarterOptionss}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                // onChange={setMonth}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={true}
                isMulti={true}
                styles={customStyles}
                closeMenuOnSelect={false}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>

      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="text-center">
            <div
              className="spinner-border text-primary mb-3"
              role="status"
            ></div>
            <p
              className="mb-3"
              style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}
            >
              Loading...
            </p>
          </div>
        </div>
      )}

      {showDashboard && (
        <div>
          <div className="row">
            <div className="col-md-12">
              <DomainTile
                title="Argatas"
                showBackButton={true}
                mainPagePath="/Procure-To-Pay"
              />
            </div>
            <div className="mb-2">
              {/* <div className="multi-bar-chart">
                <div className="d-flex flex-wrap">
                  <InfoCards
                    title={"Paid On Time"}
                    // value={CardData["POCreation"] ?.length ? CardData["POCreation"] : 0}
                    value={0}
                  />
                  <InfoCards
                    title="PO Penetration"
                    // value={VendorPaymentData["MSME_Vend"]?.length ? VendorPaymentData["MSME_Vend"] : 0 }
                    value={0}
                  />

                  <InfoCards
                    title={"PO creation Volume"}
                    value={
                      CardData["PO_Creation"]?.length
                        ? CardData["PO_Creation"]
                        : 0
                    }
                  />
                  <InfoCards
                    title={"Invoice Verified"}
                    value={
                      CardData["Invoice_Veri"]?.length
                        ? CardData["Invoice_Veri"]
                        : 0
                    }
                  />
                </div>
              </div> */}
                      <div className="row g-3">
          <div className="col-12">
            <div className="d-flex flex-wrap mb-2">
              <div className="row g-3 w-100 px-2">
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6">
                  <TileComp
                    title="Paid on Time"
                    number={
                      CardData["POT"]?.[0]?.[0] == null
                        ? "NA"
                        : CardData["POT"][0][0]
                    }
                    gradient={paidOnTimeGradient}
                    popupContent="This metric is the Manual CSV DATA"
                    showDownload={false}
                  />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6">
                  <TileComp
                    title="PO Penetration"
                    number={
                      CardData["PO_Penetration"]?.[0]?.[0] == null
                        ? "NA"
                        : CardData["PO_Penetration"][0][0]
                    }
                    gradient={emeraldGradient}
                    popupContent="This metric is the Manual CSV DATA"
                    showDownload={false}
                  />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6">
                  <TileComp
                    title="PO Creation Volume"
                    number={
                      CardData["PO_Creation"]?.[0]?.[0] == null
                        ? "NA"
                        : CardData["PO_Creation"][0][0]
                    }
                    gradient={blueGradient}
                    popupContent="This metric is the Manual CSV DATA"
                    showDownload={false}
                  />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6">
                  <TileComp
                    title="Invoice Verified"
                    number={
                      CardData["Invoice_Veri"]?.[0]?.[0] == null
                        ? "NA"
                        : CardData["Invoice_Veri"][0][0]
                    }
                    gradient={amberGradient}
                    popupContent="This metric is the Manual CSV DATA"
                    showDownload={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <DomainTile title="Purchase and MDM" showBackButton={false} />
              <div className="row mb-2 mt-2">
                <div className="col-lg-12 mb-1">
                  <DashboardSection
                    title="PO Creation"
                    disableDetailView={true}
                    detailPath="/Procure-To-Pay"
                    disableInfoIcon={false}
                    popupContent="Manual CSV DATA"
                  >
                    <BarLineChart
                      datasets={generateDataset(POCreationData)}
                      chartData={POCreationData}
                      height={250}
                    />
                  </DashboardSection>
                </div>

                <div className="col-lg-12 mb-1">
                  <DashboardSection
                    title="SCS (Service Center Sheet) Creation"
                    disableDetailView={true}
                    detailPath="/Procure-To-Pay"
                    disableInfoIcon={false}
                    popupContent="Manual CSV DATA"
                  >
                    <BarLineChart
                      datasets={generateDataset(SCSData)}
                      chartData={SCSData}
                      height={250}
                    />
                  </DashboardSection>
                </div>

                <div className="col-lg-12 mb-1">
                  <DashboardSection
                    title="MDM Entries Created/Updated"
                    disableDetailView={true}
                    detailPath="/Procure-To-Pay"
                    disableInfoIcon={false}
                    popupContent="Manual CSV DATA"
                  >
                    <BarLineChart
                      datasets={generateDataset(MDMData)}
                      chartData={MDMData}
                      height={250}
                    />
                  </DashboardSection>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <DomainTile title="Accounts Payables" showBackButton={false} />
              <div className="row mb-2 mt-2">
                <div className="col-lg-12 mb-1">
                  <DashboardSection
                    title="Invoice Verification"
                    disableDetailView={true}
                    detailPath="/Procure-To-Pay"
                    disableInfoIcon={false}
                    popupContent="Manual CSV DATA"
                  >
                    <BarLineChart
                      datasets={generateDataset(InvoiceData)}
                      chartData={InvoiceData}
                      height={250}
                    />
                  </DashboardSection>
                </div>

                <div className="col-lg-12 mb-1">
                  <DashboardSection
                    title="Vendor Queries"
                    disableDetailView={true}
                    detailPath="/Procure-To-Pay"
                    disableInfoIcon={false}
                    popupContent="Manual CSV DATA"
                  >
                    <BarLineChart
                      datasets={generateDataset(VendorQueriesData)}
                      chartData={VendorQueriesData}
                      height={250}
                    />
                  </DashboardSection>
                </div>

                <div className="col-lg-12 mb-1">
                  <DashboardSection
                    title="Vendor Reconciliations"
                    disableDetailView={true}
                    detailPath="/Procure-To-Pay"
                    disableInfoIcon={false}
                    popupContent="Manual CSV DATA"
                  >
                    <BarLineChart
                      datasets={generateDataset(VendorReconData)}
                      chartData={VendorReconData}
                      height={250}
                    />
                  </DashboardSection>
                </div>
              </div>
            </div>
          </div>
          <div className="row" style={{fontSize:"12px", color:"red"}}>
          <Marquee speed={30} gradient={false}>
          Last Refresh Date:- <b>{stripedYesterrdayDate}</b>
          </Marquee>
        </div>
        </div>
      )}
    </>
  );
}

export default AgratasP2PMainComp;